import ColorBoxInput from "components/Properties/InputComponents/ColorboxInput";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";
import BaseComponent from "../BaseComponent";

const FogComponent = ({scene, inputOnChange, dropdownOnChange, dropdownOpened, setDropdownOpened, checkboxOnChange, colorOnChange}) => {
  const fog = scene.fog;
  const isFogActive = fog || false;
  const fogColor = fog && `#${fog.color.getHexString()}`;
  const fogMode = fog && fog.isFogExp2 ? "Exponential" : "Linear";
  const fogDensity = fog && fog.isFogExp2 && fog.density;
  const fogNear = fog && fog.isFog && fog.near;
  const fogFar = fog && fog.isFog && fog.far;

  return (
    <BaseComponent title="Fog" foldable={true}>
      <ToggleInput name="FogActive" checked={isFogActive} checkboxOnChange={checkboxOnChange} />
      {isFogActive && (
        <>
          <ColorBoxInput name="FogColor" objectColor={fogColor} colorOnChange={colorOnChange} depth={1} />
          <DropDownInput
            name="FogMode"
            array={["Exponential", "Linear"]}
            dropdownOnChange={dropdownOnChange}
            value={fogMode}
            dropdownOpened={dropdownOpened}
            setDropdownOpened={setDropdownOpened}
            depth={1}
          />
          {fogMode === "Exponential" && (
            <NumberSliderInput
              name="FogDensity"
              min={0}
              max={0.1}
              step={0.001}
              value={fogDensity}
              inputOnChange={inputOnChange}
              depth={1}
            />
          )}
          {fogMode === "Linear" && (
            <>
              <NumberSliderInput name="FogNear" min={0} max={1000} step={1} value={fogNear} inputOnChange={inputOnChange} depth={1} />
              <NumberSliderInput name="FogFar" min={0} max={1000} step={1} value={fogFar} inputOnChange={inputOnChange} depth={1} />
            </>
          )}
        </>
      )}
    </BaseComponent>
  );
};

export default FogComponent;
